import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ServiceDocHdrContainerModel } from '../../../../../../models/aggregates/erp/rma';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiVisa, BasicApiResponseModel } from '../../shared';

// /core2/tnt/dm/erp/e-invoice/ppl/to-xap-submission-queues/process/execute/backoffice-ep

@Injectable({
  providedIn: 'root'
})

export class MyPeppolToXapSubmissionQueueService extends BaseApiTemplateService<ServiceDocHdrContainerModel> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/e-invoice/ppl/to-xap-submission-queues/process/execute/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/e-invoice/ppl/to-xap-submission-queues/process/execute/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/e-invoice/ppl/to-xap-submission-queues/process/execute/backoffice-ep';
    this.httpClient = http;
  }

  public submitQueue(
    dtoObject: any,
    visa: ApiVisa
  ):Observable<BasicApiResponseModel<any>> {

    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
